import { CONTACT_EMAIL, GAME_NAME } from '@geosport/shared';
import { Shell } from '../components/Shell';

export function Terms() {
  return (
    <Shell title="Terms">
      <div className="flex flex-col gap-4 text-sm leading-relaxed text-white/80">
        <p>By playing {GAME_NAME} you agree to these short terms.</p>
        <section>
          <h2 className="mb-1 font-semibold text-white">Fair play</h2>
          <p>
            One scored attempt per person per day. Automating play, tampering with requests or using
            multiple identities to climb the leaderboard may lead to entries being removed.
          </p>
        </section>
        <section>
          <h2 className="mb-1 font-semibold text-white">Display names</h2>
          <p>
            Names must not be offensive, impersonate others or include personal contact details. We
            may change or remove names that break this rule.
          </p>
        </section>
        <section>
          <h2 className="mb-1 font-semibold text-white">Content</h2>
          <p>
            Clues and stories are written in our own words, with the help of AI, and checked against
            public sources (Wikidata and Wikipedia). If you spot a mistake, please tell us at{' '}
            <a className="underline" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>
            . Map data © OpenStreetMap contributors, rendered with Protomaps and MapLibre.
          </p>
        </section>
        <section>
          <h2 className="mb-1 font-semibold text-white">Availability</h2>
          <p>
            The game is provided free and as-is. We do our best to keep it running every day but
            cannot guarantee availability, and we may change or end the service at any time.
          </p>
        </section>
      </div>
    </Shell>
  );
}
